// Persistencia local de BINARIOS de firmas pendientes (offline real, v1).
// Gemelo de `offlinePhotosStore`: las firmas (PNG) son binarios → IndexedDB vía
// localforage (serializa Blob nativamente). Cada firma se keyea por un `localId`
// único. El daemon las sube a S3 al reconectar (contra la presigned de firma) y
// luego las borra. Todo best-effort: si IndexedDB falla, degrada a no-op/null/[].
import localforage from 'localforage';

const store = localforage.createInstance({
  name: 'prolift',
  storeName: 'offline-signatures',
});

const sameMantencion = (rec, mantencionId) =>
  rec != null && String(rec.mantencionId) === String(mantencionId);

export async function saveSignature(localId, data) {
  if (localId == null) return;
  try {
    await store.setItem(String(localId), {
      ...data,
      localId: String(localId),
      createdAt: Date.now(),
    });
  } catch {
    // best-effort: idb no disponible / quota
  }
}

export async function loadSignature(localId) {
  if (localId == null) return null;
  try {
    return (await store.getItem(String(localId))) ?? null;
  } catch {
    return null;
  }
}

export async function loadSignaturesForMantencion(mantencionId) {
  const out = [];
  try {
    await store.iterate((rec) => {
      if (sameMantencion(rec, mantencionId)) out.push(rec);
    });
  } catch {
    return [];
  }
  return out;
}

export async function deleteSignature(localId) {
  if (localId == null) return;
  try {
    await store.removeItem(String(localId));
  } catch {
    // best-effort
  }
}

export async function deleteSignaturesForMantencion(mantencionId) {
  try {
    const toDelete = [];
    await store.iterate((rec, key) => {
      if (sameMantencion(rec, mantencionId)) toDelete.push(key);
    });
    for (const key of toDelete) {
      // eslint-disable-next-line no-await-in-loop
      await store.removeItem(key);
    }
  } catch {
    // best-effort
  }
}
